import { render, staticRenderFns } from "./IndexUsersPage.vue?vue&type=template&id=5d8e1e40&"
import script from "./IndexUsersPage.vue?vue&type=script&lang=js&"
export * from "./IndexUsersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports